import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Managed IT services hand the day-to-day running of your technology to a dedicated team. We monitor, maintain, secure and support your systems proactively — preventing problems rather than just reacting to them.",
    "You get predictable costs, reliable systems and a single team accountable for keeping your IT healthy end to end.",
];

const FEATURES = [
    { title: "Proactive management", text: "Continuous monitoring and maintenance that heads off issues early." },
    { title: "Security & compliance", text: "Patching, backups and controls that keep your data protected." },
    { title: "Predictable costs", text: "A managed model that turns unpredictable IT spend into a clear plan." },
    { title: "Single accountable team", text: "One partner responsible for the whole of your IT operation." },
];

const CHECKS = [
    "Proactive monitoring & maintenance",
    "Security & backup management",
    "Help desk & support",
    "Patch & update management",
    "IT strategy & reporting",
];

export default function ManagedItServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Managed IT Services" eyebrowAs="span">
                    Your IT, fully looked after — proactive, end-to-end management that keeps everything running so you can focus on the business.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
